export const calculatePercentage = (value: number, min: number, max: number) => ((value - min) / (max - min)) * 100 + '%'

export const rangeLinearGradient = (value: number, min: number, max: number) => {
  const percentage = calculatePercentage(value, min, max)
  const newBackgroundStyle = `linear-gradient(90deg, var(--systemOrange) 0% ${percentage}, #EBEDEE ${percentage} 100%)`;

  return newBackgroundStyle
}